import KendoPivotGrid from '../KendoPivotGrid'
import KendoPivotConfigurator from '../KendoPivotConfigurator'

let KendoPivotGridInstaller = class {
    static install(Vue) {
        Vue.component(KendoPivotGrid.name, KendoPivotGrid)
        Vue.component(KendoPivotConfigurator.name, KendoPivotConfigurator)
    }
}

export default KendoPivotGridInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoPivotGridInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/kendo-pivotgrid-installer/index.js